export default __webpack_public_path__ + "static/media/ca.102b45b2.svg";